import { render, staticRenderFns } from "./StructureDetail.vue?vue&type=template&id=6abc4fd8&"
import script from "./StructureDetail.vue?vue&type=script&lang=js&"
export * from "./StructureDetail.vue?vue&type=script&lang=js&"
import style0 from "./StructureDetail.vue?vue&type=style&index=0&id=6abc4fd8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports